/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/**
 * @file
 * A JavaScript file for making select boxes customizable
 *
 */

function floatingLabel() {
  const inputs = document.querySelectorAll('.js-form-item:not(.js-form-type-textarea) input.form-item__textfield');

  if (!inputs.length > 0) return;

  inputs.forEach((input) => {
    if (input.value.length > 0 || input.getAttribute('autofocus') === 'autofocus') {
      input.parentElement.classList.add('focused');
    }

    input.addEventListener('focus', (e) => {
      input.parentElement.classList.add('focused');
    });

    input.addEventListener('blur', (e) => {
      if (input.value.length > 0) return;
      input.parentElement.classList.remove('focused');
    });
  });

  // subscribe form input auto focus
  const subscribeInput = document.querySelector('#subscribe-modal-wrapper input.form-item__textfield');

  if (subscribeInput) {
    subscribeInput.parentElement.classList.add('focused');
  }
}

(function insightListingExposeFilters() {
  const insightListingForm = document.querySelector('.insight-listing-form-wrapper .views-exposed-form');
  if (!insightListingForm) return;

  const imSelect = insightListingForm.querySelector('.js-form-item-field-investment-manager-target-id');
  const typeSelect = insightListingForm.querySelector('.js-form-item-field-manager-category-target-id');
  const tagsSelect = insightListingForm.querySelector('.js-form-item-field-tags-target-id');
  const searchField = insightListingForm.querySelector('.js-form-item-combine');
  const submitBtn = insightListingForm.querySelector('.form-actions');

  const btnMoreFilters = document.createElement('div');
  btnMoreFilters.id = 'more-filters';
  btnMoreFilters.innerText = 'More filters';

  const formGroup1 = document.createElement('div');
  formGroup1.classList.add('form-group-1');

  if (searchField) formGroup1.appendChild(searchField);
  if (submitBtn) formGroup1.appendChild(submitBtn);

  const formGroup2 = document.createElement('div');
  formGroup2.classList.add('form-group-2');

  if (typeSelect) formGroup2.appendChild(typeSelect);
  if (tagsSelect) formGroup2.appendChild(tagsSelect);
  if (imSelect) formGroup2.appendChild(imSelect);

  insightListingForm.append(formGroup1);
  insightListingForm.append(btnMoreFilters);
  insightListingForm.append(formGroup2);

  btnMoreFilters.addEventListener('click', () => {
    formGroup2.classList.toggle('expanded');
    btnMoreFilters.classList.toggle('active');
  });

  insightListingForm.classList.add('form-ready');
})();

function initNiceSelects() {
  const selects = document.querySelectorAll('select:not([data-yourir])');

  if (selects.length > 0) {
    selects.forEach((select) => {
      if (!select.nextElementSibling?.classList.contains('nice-select')) {
        const isCountrySelect = select.name === 'country';
        NiceSelect.bind(select, { searchable: isCountrySelect });
        select.style.display = 'none';
      }
    });
  }
}

(function (Drupal, $) {
  Drupal.behaviors.niceSelect = {
    attach(context) {
      'use strict';

      initNiceSelects();
      floatingLabel();

      $(document).ajaxComplete(() => {
        initNiceSelects();
        floatingLabel();
      });
    },
  };
})(Drupal, jQuery);
